<!-- WalletInfo.svelte -->
<script>
    export let userAddress;
    export let chainName;
    export let userBalance;
  </script>
  
  {#if userAddress}
    <div>
      <p>Connected Wallet: {userAddress}</p>
      <p>Blockchain: {chainName}</p>
      <p>Balance: {userBalance}</p>
    </div>
  {:else}
    <p>Wallet not connected</p>
  {/if}
  